import React, { useState, useEffect, useRef } from "react";
import "./testimonialSlider.scss";
import {
  Avatar,
  ecoli,
  excelr,
  newmiles,
  Quizziz,
  Quotes,
  relevel,
  tperson,
} from "../../../../../../../helpers/constant/imageUrl";

import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

const TestimonialSlider = () => {
  const testimonials = [
    {
      id: 1,
      company: "Edtech",
      text: "Student Satisfaction is at the core of our DNA. Utilitarian Labs, with their expertise, has enabled us to meaningfully capture student with ease.",
      companylogo: excelr,
      author: "Amit Tavva",
      position: "Head of Digital Marketing",
      avatar: tperson,
    },
    {
      id: 2,
      company: "Manufacturing",
      text: "The Utilitarian Labs team has been a game changer for our sales team. Their Salesforce automation solution streamlined the entire lead qualification process, from SAL to SQL, and made lead nurturing more efficient. Now our reps can focus on what they do best, ie closing deal",
      companylogo: ecoli,
      author: "Rajkumar Annadurai",
      position: "Sr. Manager Business Operation",
      avatar: tperson,
    },
      {
      id: 3,
      isMiles: true,
      company: "Edtech",
      text: "We had a great experience working with Utilitarian Labs on our Salesforce implementation. The team demonstrated strong Salesforce expertise, understood our business requirements well, and worked closely with our teams throughout the implementation. Their responsiveness, ownership, and commitment to delivering the solution as planned made the overall experience smooth and collaborative. We look forward to continuing our association with Utilitarian Labs as we further leverage Salesforce to drive our business.",
      companylogo: newmiles,
      author: "Sachin Kashyap K",
      position: "Deputy Chief of Staff",
      avatar: tperson,
    },

    {
      id: 4,
      company: "Edtech",
      text: "We are in a high, fixed cost Industry where profitability is driven by utilization. Utilitarian Labs provided the technology solutions that offered daily metrics, complementing Salesforce Implementation, and giving us much of what we needed.",
      companylogo: relevel,
      author: "Shreyas Bharadwaj",
      position: "Sales Director",
      avatar: tperson,
    },
    {
      id: 5,
      company: "Recruitment & Staffing",
      text: "While many companies have slowed down during the COVID-19 pandemic, our productivity has increased, thanks to technology like salesforce empowered by Utilitarian Labs.",
      companylogo: Quizziz,
      author: "Sunil Jain",
      position: "Head of Sales",
      avatar: tperson,
    },
  ];

  const [rightStack, setRightStack] = useState([...testimonials]);
  const [leftStack, setLeftStack] = useState([]);
  const [current, setCurrent] = useState(rightStack[0]);
  const [phase, setPhase] = useState("RIGHT");
  const intervalRef = useRef(null);
  const resumeTimeoutRef = useRef(null);

  const clearTimers = () => {
    clearInterval(intervalRef.current);
    clearTimeout(resumeTimeoutRef.current);
  };

  const startAutoSlider = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      if (phase === "RIGHT" && rightStack.length > 0) {
        moveRight();
      } else if (phase === "LEFT" && leftStack.length > 0) {
        moveLeft();
      }
    }, 4000);
  };

  useEffect(() => {
    startAutoSlider();
    return clearTimers;
  }, [rightStack, leftStack, phase]);

  const pauseAndResumeAutoSlider = () => {
    clearTimers();
    resumeTimeoutRef.current = setTimeout(() => {
      startAutoSlider();
    }, 5000);
  };

  const moveRight = () => {
    if (rightStack.length > 0) {
      const [next, ...rest] = rightStack;
      setCurrent(next);
      setRightStack(rest);
      setLeftStack((prev) => [...prev, next]);
      if (rest.length === 0) setPhase("LEFT");
    }
  };

  const moveLeft = () => {
    if (leftStack.length > 0) {
      const [next, ...rest] = leftStack;
      setCurrent(next);
      setLeftStack(rest);
      setRightStack((prev) => [...prev, next]);
      if (rest.length === 0) setPhase("RIGHT");
    }
  };

  const handleNext = () => {
    if (leftStack.length === 0) return;
    pauseAndResumeAutoSlider();
    moveLeft();
  };

  const handlePrev = () => {
    if (rightStack.length === 0) return;
    pauseAndResumeAutoSlider();
    moveRight();
  };

  return (
    <div className="testimonial-slider">
      <div className="mainprob">
        <div className="slider-header">
          <h1 className="textimonial-head">
            What Our Clients <br /> Say About Us?
          </h1>
        </div>

        <div className="slider-container">
          <div className="slider-wrapper">
            <div className="slider-inner">
              {testimonials.map((testimonial) => {
                let position = 0;
                if (testimonial.id === current?.id) {
                  position = 0;
                } else if (phase === "RIGHT") {
                  if (rightStack.find((t) => t.id === testimonial.id)) {
                    position =
                      rightStack.findIndex((t) => t.id === testimonial.id) + 1;
                  } else {
                    position = -(
                      leftStack.findIndex((t) => t.id === testimonial.id) + 1
                    );
                  }
                } else {
                  if (leftStack.find((t) => t.id === testimonial.id)) {
                    position = -(
                      leftStack.findIndex((t) => t.id === testimonial.id) + 1
                    );
                  } else {
                    position =
                      rightStack.findIndex((t) => t.id === testimonial.id) + 1;
                  }
                }

                let zIndex = 1;
                let translateX = 0;
                let scale = 0.8;
                let opacity = 0.5;
                let rotation = 0;
                let bgColor;

                if (position === 0) {
                  zIndex = 10;
                  scale = 1;
                  opacity = 1;
                  translateX = 0;
                  rotation = 0;
                } else if (position > 0) {
                  if (position === 1) {
                    zIndex = 9;
                    translateX = 30;
                    scale = 0.9;
                    opacity = 0.7;
                    rotation = 4;
                    bgColor = "#CCC8E8";
                  } else if (position === 2) {
                    zIndex = 8;
                    translateX = 40;
                    scale = 0.85;
                    opacity = 0.8;
                    rotation = 6;
                    bgColor = "#8C84CB";
                  }
                } else {
                  const absPos = Math.abs(position);
                  if (absPos === 1) {
                    zIndex = 9;
                    translateX = -30;
                    scale = 0.9;
                    opacity = 0.9;
                    rotation = -4;
                    bgColor = "#CCC8E8";
                  } else if (absPos === 2) {
                    zIndex = 8;
                    translateX = -40;
                    scale = 0.85;
                    opacity = 0.8;
                    rotation = -6;
                    bgColor = "#8C84CB";
                  }
                }

                return (
                  <div
                    key={testimonial.id}
                    className={`testimonial-card ${
                      testimonial.isMiles ? "miles-card" : ""
                    }`}
                    style={{
                      transform: `translateX(${translateX}px) scale(${scale}) rotate(${rotation}deg)`,
                      zIndex: zIndex,
                      opacity: opacity,
                      backgroundColor: `${bgColor} !important`,
                      margin: "auto",
                    }}
                  >
                    <img
                      loading="lazy"
                      src={Quotes}
                      alt="quotation marks"
                      className="quotes"
                    />
                    <div className="client_type">{testimonial.company}</div>
                    <div className="desc">{testimonial.text}</div>
                    <div className="clientimg">
                      <img
                        loading="lazy"
                        src={testimonial.companylogo}
                        alt="Company logo"
                        className="img_client"
                      />
                    </div>
                    <div className="client-info">
                      <div className="pic">
                        <img
                          loading="lazy"
                          src={Avatar}
                          alt="Client"
                          className="personpic"
                        />
                      </div>
                      <div className="ml-2">
                        <p className="personName">{testimonial.author}</p>
                        <span>{testimonial.position}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="left-btn">
            <button
              className={`nav-button tleftbtn ${
                rightStack.length === 0 ? "disabled" : ""
              }`}
              onClick={handlePrev}
              disabled={rightStack.length === 0}
            >
              <KeyboardArrowLeftRoundedIcon
                sx={{
                  color: rightStack.length === 0 ? "white" : "orange",
                  fontSize: { xs: "1rem", md: "2rem" },
                }}
              />
            </button>
          </div>
          <div className="right-btn">
            <button
              className={`nav-button trightbtn ${
                leftStack.length === 0 ? "disabled" : ""
              }`}
              onClick={handleNext}
              disabled={leftStack.length === 0}
            >
              <KeyboardArrowRightRoundedIcon
                sx={{
                  color: leftStack.length === 0 ? "white" : "orange",
                  fontSize: { xs: "1rem", md: "2rem" },
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;
